import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useTheme } from '../../contexts/ThemeContext';

export default function AppToaster() {
  const { isDarkMode } = useTheme();

  const baseStyle = isDarkMode
    ? {
        background: '#1e293b',
        color: '#f1f5f9',
        border: '1px solid #334155',
        boxShadow: '0 10px 25px rgba(0,0,0,0.35)',
      }
    : {
        background: '#ffffff',
        color: '#0f172a',
        border: '1px solid #e2e8f0',
        boxShadow: '0 10px 25px rgba(15, 23, 42, 0.08)',
      };

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: baseStyle,
        success: {
          duration: 3000,
          iconTheme: {
            primary: '#10B981',
            secondary: isDarkMode ? '#1e293b' : '#ffffff',
          },
        },
        error: {
          duration: 5000,
          iconTheme: {
            primary: '#EF4444',
            secondary: isDarkMode ? '#1e293b' : '#ffffff',
          },
        },
      }}
    />
  );
}
